import { render, staticRenderFns } from "./AdjustTable.vue?vue&type=template&id=484b8064&scoped=true&"
import script from "./AdjustTable.vue?vue&type=script&lang=js&"
export * from "./AdjustTable.vue?vue&type=script&lang=js&"
import style0 from "./AdjustTable.vue?vue&type=style&index=0&id=484b8064&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b8064",
  null
  
)

export default component.exports